import React from 'react'
import * as styles from './loading.styl'

export interface Props {}

export const Loading: React.FC<Props> = () => (
  <div className={styles.loading}>Loading </div>
)

export default Loading
